import dayjs from 'dayjs';
import { IBooking } from '../interfaces/heavyDutyMachinery/IBooking';

// Mirrors BookingController.CancellationWindowHours -- used only for an
// immediate disabled-state hint; the backend is the actual authority and
// re-checks this on every cancel request.
export const CANCELLATION_WINDOW_HOURS: Record<string, number | undefined> = {
  Flexible: 24,
  Moderate: 72,
  Strict: undefined,
};

/** Whether the CALLING guest can self-service cancel this booking right now (the backend also forbids a host from cancelling via this endpoint at all). */
export const canOfferCancel = (booking: IBooking): boolean => {
  if (booking.status !== 'Pending' && booking.status !== 'Confirmed') return false;
  const windowHours = CANCELLATION_WINDOW_HOURS[booking.cancellationPolicy];
  if (windowHours == null) return false;
  return dayjs().isBefore(dayjs(booking.startAt).subtract(windowHours, 'hour'));
};
